import { render } from "./Hakafa.vue?vue&type=template&id=276f206f&scoped=true"
import script from "./Hakafa.vue?vue&type=script&lang=js"
export * from "./Hakafa.vue?vue&type=script&lang=js"

import "./Hakafa.vue?vue&type=style&index=0&id=276f206f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276f206f"]])

export default __exports__